import { Component, Input } from '@angular/core'

@Component({
  selector: 'default-button-outlined',
  standalone: true,
  imports: [],
  templateUrl: './default-button-outlined.component.html',
})
export class DefaultButtonOutlinedComponent {
  @Input() text?: string
  @Input() color?: string
  @Input() disabled?: boolean
  @Input() click!: () => void
  @Input() type?: string
  @Input() className?: string
  @Input() width?: string = '100%'
  @Input() height?: string = '40px'
  @Input() backgroundColor?: string

  hoverColor = 'bg-buttonFilledHover'

  constructor() {
    this.color = ''
    this.disabled = false
    this.type = 'button'
    this.className = ''
    this.backgroundColor = 'bg-buttonFilledDefault'
  }

  onClickButton() {
    if (this.type === 'button') {
      this.click()
    }
  }
}
